import { Numeric4BoxMultipleOutlineIcon } from './Numeric4BoxMultipleOutlineIcon';

/**
 * author: Google
 * id EB320CFB-296A-4C6F-9585-76CA21DDCD04
 * name numeric-4-box-multiple-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-4-box-multiple-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const Numeric4BoxesOutlineIcon = Numeric4BoxMultipleOutlineIcon;
export default Numeric4BoxesOutlineIcon